import { authorizeIfLoggedIn } from "../../../components/Auth/AuthorizedApiClientBase";
import { MembershipClient } from "./generated/MembershipClient"

const client = new MembershipClient(process.env.MEMBERSHIP_BACKEND_URL);

export const MembershipClientFactory = () => {
    authorizeIfLoggedIn(client);
    return client;
}